import $ from 'jquery'
import jQuery from 'jquery'
import 'rails-ujs'
import 'foundation-sites'

$(document).on('turbolinks:load', function(){
	setTimeout( function(){$(document).foundation()}, 50 )
	// $(document).foundation()
});
